import { useLocation } from 'react-router-dom';

const WithPropsRouter = (Component) => (props) => {
  return <Component {...props} location={useLocation()} />;
};

export default WithPropsRouter;
